module.exports = __webpack_public_path__ + "static/img/5.0c3709d.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/internetimg/5.png
// module id = 3K4+
// module chunks = 9